﻿import Modal from './modal';
import $ from 'jquery';

var $confirmation: JQuery = null;
var $content: JQuery = null;
var $title: JQuery = null;
var $yesButton: JQuery = null;
var $noButton: JQuery = null;

var yesId: string = 'confirmation-dialog-yes-button';
var noId: string = 'confirmation-dialog-no-button';

export class Confirmation {
  static get id(): string {
    return 'confirmation-dialog';
  }

  static show(options: IConfirmationOptions): void {
    new Confirmation(options).open();
  }
  private DEFAULTS = {
    title: 'Confirm',
    yesCaption: 'Yes',
    noCaption: 'No',
    showOnTarget: false,
    modalSize: 'modal-md'
  }
  private options: IConfirmationOptions;
  constructor(options: IConfirmationOptions) {
    this.options = $.extend({}, this.DEFAULTS, options);

    if (!this.options)
      throw new Error('Options are required');
    if (!this.options.content)
      throw new Error('The option "content" is required');
    if (!this.options.callback)
      throw new Error('The option "callback" is required');
    if (this.options.showOnTarget && (this.options.$target == null || this.options.$target.length == 0))
      throw new Error('A target must be provided for showing a confirmation modal on target');
  }
  private open(): void {
    this.buildTemplate();
    this.applyOptionsToContent();
    Modal.open({
      content: $confirmation,
      $element: this.options.$target
    });
  }
  private buildTemplate(): void {
    $confirmation = $('<div>').addClass(`modal ${this.options.modalSize}`).attr('id', Confirmation.id).attr('data-modal-id', 'confirmation-modal');

    var $header = $('<div>').addClass('modal-header');
    $title = $('<h1>').addClass('modal-title');
    $header.append($title);
    $header.append('<a class="button button-icon modal-title-close" data-dismiss="on" >&#10006;</a></h1>');

    $content = $('<div>').addClass('modal-content spacer-all');

    var $actions = $('<div>').addClass('modal-actions');
    var $primaryActions = $('<div>').addClass('modal-primary-actions').appendTo($actions);
    $yesButton = $('<button>').addClass('button').addClass('button-raised button-primary').attr('id', yesId).attr('data-default', 'on').attr('type', 'button');
    $noButton = $('<button>').addClass('button').addClass('button-raised').attr('id', noId).attr('data-dismiss', 'on').attr('type', 'button');
    $primaryActions.append($noButton).append($yesButton);

    $confirmation
      .append($header)
      .append($content)
      .append($actions);

    // ensure we wire only once
    $(document).off('click.rustig.confirmation.yes', '#' + yesId);
    $(document).on('click.rustig.confirmation.yes', '#' + yesId, (e : JQueryEventObject) => this.onYesClicked(e));
  }

  private applyOptionsToContent(): void {
    $title.prepend(this.options.title);
    $content.html(this.options.content);
    $yesButton.html(this.options.yesCaption);
    $noButton.html(this.options.noCaption);
  }
  private onYesClicked(e: JQueryEventObject): void {
    $('#' + yesId).disable();
    this.options.callback();
  }
}

// CONFIRMATION INTERFACES
export interface IConfirmationOptions {
  content: any;
  callback: Function;
  title?: string;
  yesCaption?: string;
  noCaption?: string;
  onCancel?: Function;
  showOnTarget?: boolean;
  $target?: JQuery;
  modalSize?: string;
}

export default Confirmation;